import { downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';
import ngInfiniteScroll from 'ng-infinite-scroll';

import { AgentDesktopRouter } from './agent-interface/agent-desktop-router';
import { default as AgentDesktop } from './agent-interface/agent-desktop.module.ajs';
import { default as AgentCore } from './core/agent-core.module.ajs';

export default module('contact.agent', [ngInfiniteScroll, AgentDesktop, AgentCore]).factory(
  'agentDesktopRouter',
  downgradeInjectable(AgentDesktopRouter)
).name;
